/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ReportColumns {
    REPORT_TAG = 'report_tag',
    REPORT_NAME = 'report_name',
    REPORT_ID = 'report_id',
    IS_SUBJECT = 'is_subject',
}
